import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    IconButton,
    Divider,
    CircularProgress,
    Fade,
} from "@material-ui/core";
import FlagIcon from "@material-ui/icons/Flag";
import CloseIcon from "@material-ui/icons/Close";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import Tooltip from "@material-ui/core/Tooltip";

import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";

import RichTextEditor from "react-rte";
import { NoteType } from "./NoteType";
import { NoteReviewer } from "./NoteReviewer";
import { TaggedPM } from "./TaggedPM";
import { NoteLabel } from "./NoteLabel";
import { FlagFileModel } from "./FlagFileModel";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { useQueryClient } from "react-query";
import { useReportFlag, useReportUpdateNote } from "../../../common/CommonMutations";

export const NoteViewer = ({ id, url, invalidate, getNotes }: any) => {



    const [usedLabels, setUsedLabels] = useState<any[]>([]);
    const [files, setFiles] = React.useState<any[]>([]);
    const [selectedNoteType, setSelectedNoteType] = React.useState<any>("");
    const [taggedReviewer, setTaggedReviewer] = React.useState<any>(null);
    const [ProjectManagers, setProjectManagers] = React.useState<any[]>([]);



    const [open, setOpen] = useState(false);
    const [editorContent, setEditorContent] = useState(
        RichTextEditor.createEmptyValue()
    );
    const [isLoading, setIsLoading] = useState(false);

    const { mutateAsync: mutateNote } = useReportFlag();
    const { authAxios } = useFetchContext();
    const queryClient = useQueryClient();

    const handleToggle = () => {
        setOpen(!open);
    }
    const handleEditorChange = (value: any) => setEditorContent(value);

    return (
        <>
            <Tooltip title="Create Note">
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FlagIcon />}
                    onClick={handleToggle}
                >

                </Button>
            </Tooltip>

            <Formik
                initialValues={{ subject: "" }}
                validationSchema={Yup.object({
                    subject: Yup.string().required("Subject is required"),
                })}
                onSubmit={async (values, { resetForm }) => {

                    const labelIds = usedLabels.map((label) => label.id);
                    const projectManagersid = ProjectManagers.map((pm) => pm.id);
                    const reviewerId = taggedReviewer ? taggedReviewer.id : null;


                    console.log({
                        type: selectedNoteType,
                        subject: values.subject,
                        comment: editorContent.toString("markdown"),
                        reviewer: reviewerId,
                        labels: labelIds,
                        tagged_users: projectManagersid,
                        report: id,
                    });

                    setIsLoading(true);



                    try {

                        await mutateNote({
                            authAxios,
                            type: selectedNoteType,
                            subject: values.subject,
                            comment: editorContent.toString("markdown"),
                            reviewer: reviewerId,
                            labels: labelIds,
                            tagged_users: projectManagersid,
                            report: id,
                        });

                        if(selectedNoteType===3){
                        toast.success("Flag created successfully!");
                        }else{
                            toast.success("Note Created successfully!")
                        }
                        

                        // Reset states
                        resetForm();
                        setEditorContent(RichTextEditor.createEmptyValue());
                        setUsedLabels([]);
                        setTaggedReviewer(null);
                        setProjectManagers([]);
                        setFiles([]);
                        setIsLoading(false);
                        handleToggle();

                    } catch (error) {
                        console.error(" Error submitting note:", error);
                        toast.error("Failed to create note.");
                        setIsLoading(false);
                    }



                }}
            >
                {({ errors, touched, submitForm }) => (
                    <Form>
                        <Dialog
                            open={open}
                            onClose={handleToggle}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                            fullWidth={true}
                            maxWidth={"lg"}
                        >
                            <DialogTitle>
                                <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item xs={8}>
                                        <Field
                                            name="subject"
                                            component={TextField}
                                            label="Subject"
                                            variant="outlined"
                                            fullWidth
                                            error={touched.subject && Boolean(errors.subject)}
                                            helperText={touched.subject && errors.subject}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Fade in={isLoading}>
                                            <CircularProgress size={24} />
                                        </Fade>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton onClick={handleToggle}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </DialogTitle>

                            <DialogContent>
                                <Divider style={{ marginBottom: "16px" }} />
                                <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="flex-start"
                                    spacing={1}
                                >
                                    <Grid item xs={8} style={{ marginTop: "12px" }}>
                                        <RichTextEditor
                                            value={editorContent}
                                            onChange={handleEditorChange}
                                            toolbarConfig={{
                                                display: [
                                                    "BLOCK_ALIGNMENT_BUTTONS",
                                                    "INLINE_STYLE_BUTTONS",
                                                    "BLOCK_TYPE_BUTTONS",
                                                    "BLOCK_TYPE_DROPDOWN",
                                                    "HISTORY_BUTTONS",
                                                ],
                                                BLOCK_ALIGNMENT_BUTTONS: [
                                                    { label: 'UL', style: 'unordered-list-item' },
                                                    { label: 'OL', style: 'ordered-list-item' },
                                                    { label: 'Blockquote', style: 'blockquote' },
                                                ],
                                                INLINE_STYLE_BUTTONS: [
                                                    { label: "Bold", style: "BOLD" },
                                                    { label: "Italic", style: "ITALIC" },
                                                    { label: "Strikethrough", style: "STRIKETHROUGH" },
                                                    { label: "Monospace", style: "CODE" },
                                                    { label: "Underline", style: "UNDERLINE" },
                                                ],
                                                BLOCK_TYPE_DROPDOWN: [
                                                    { label: "Normal", style: "unstyled" },
                                                    { label: "Heading Large", style: "header-one" },
                                                    { label: "Heading Medium", style: "header-two" },
                                                    { label: "Heading Small", style: "header-three" },
                                                ],
                                                BLOCK_TYPE_BUTTONS: [
                                                    { label: "UL", style: "unordered-list-item" },
                                                    { label: "OL", style: "ordered-list-item" },
                                                    { label: "Blockquote", style: "blockquote" },
                                                ],
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={3}
                                        style={{
                                            borderLeftStyle: "solid",
                                            borderWidth: "2px",
                                        }}
                                    >
                                        <Grid
                                            container
                                            direction="column"
                                            justify="center"
                                            alignItems="stretch"
                                            spacing={1}
                                        >
                                            <Grid item xs={12}>
                                                <NoteType
                                                    noteTypes={selectedNoteType}
                                                    setNoteTypes={setSelectedNoteType}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <NoteReviewer
                                                    taggedReviewer={taggedReviewer}
                                                    setTaggedReviewer={setTaggedReviewer}
                                                    isNew={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TaggedPM
                                                    projectManagers={ProjectManagers}
                                                    setprojectManagers={setProjectManagers}
                                                    isNew={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <NoteLabel
                                                    usedLabels={usedLabels}
                                                    setUsedLabels={setUsedLabels}
                                                />

                                            </Grid>
                                            {/* <Grid item xs={12}>
                                                <FlagFileModel
                                                    files={files}
                                                    setFiles={setFiles}
                                                />
                                            </Grid> */}

                                        </Grid>
                                    </Grid>
                                </Grid>

                            </DialogContent>



                            <DialogActions>
                                <Button onClick={handleToggle} color="primary">
                                    Close
                                </Button>
                                <Button
                                    color="secondary"
                                    onClick={submitForm}
                                    disabled={isLoading}
                                >
                                    Create
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Form>
                )}
            </Formik >
        </>
    );
};
